import { Box } from '@mui/material';
import { useQuizState } from '../../../providers/QuizProvider/QuizProvider.hooks';
import {
  BLACKOUT_EXPERIENCE_ANSWERS,
  BlackoutExperience
} from '../../../providers/QuizProvider/QuizProvider.types';
import QuizButton, { ButtonType } from '../../common/QuizButton';
import QuizContainer from '../../common/QuizContainer';
import QuizHeader from '../../common/QuizHeader';
import QuizQuestion from '../../common/QuizQuestion';
import QuizStepBackgroundWrapper from '../../common/QuizStepBackgroundWrapper';

function Step16() {
  const { setStep, setQuizData, quizData } = useQuizState();
  const handleClick = (type: BlackoutExperience) => {
    setQuizData((prev) => ({
      ...prev,
      blackoutExperience: type,
    }));
    setStep((prev) => prev + 1);
  };

  return (
    <QuizStepBackgroundWrapper>
      <QuizHeader
        onBack={() => {
          setStep((prev) => prev - 1);
        }}
        stepNumber={16}
        stepsNumber={19}
      ></QuizHeader>
      <QuizQuestion text="Have you blacked out or forgotten what happened after drinking more than once?"></QuizQuestion>
      <QuizContainer>
        <Box
          sx={{
            display: 'flex',
            flexDirection: 'column',
            gap: '10px',
            marginBottom: '30px',
          }}
        >
          {Object.keys(BLACKOUT_EXPERIENCE_ANSWERS).map((key) => (
            <QuizButton
              key={key}
              onClick={() => handleClick(key as keyof typeof BLACKOUT_EXPERIENCE_ANSWERS)}
              variant={ButtonType.WHITE}
              text={BLACKOUT_EXPERIENCE_ANSWERS[key as keyof typeof BLACKOUT_EXPERIENCE_ANSWERS]}
            ></QuizButton>
          ))}
        </Box>
      </QuizContainer>
    </QuizStepBackgroundWrapper>
  );
}

export default Step16;
